const broadcast = {
    en: {
        "broadcast.title": "Broadcast",
        "broadcast.compose": "New announcement",
        "broadcast.subject": "Title",
        "broadcast.body": "Message",
        "broadcast.audience": "Audience",
        "broadcast.link": "Link (optional)",
        "broadcast.send": "Send",
        "broadcast.all": "Everyone",
        "broadcast.dealers": "Dealers",
        "broadcast.staff": "Staff",
        "broadcast.history": "History",
        "broadcast.recipients": "Recipients",
        "broadcast.sentBy": "Sent by",
        "broadcast.date": "Date",
        "broadcast.none": "No broadcasts yet",
        "broadcast.sent": "Broadcast sent",
    },
    ru: {
        "broadcast.title": "Рассылка",
        "broadcast.compose": "Новое объявление",
        "broadcast.subject": "Заголовок",
        "broadcast.body": "Сообщение",
        "broadcast.audience": "Аудитория",
        "broadcast.link": "Ссылка (необязательно)",
        "broadcast.send": "Отправить",
        "broadcast.all": "Все",
        "broadcast.dealers": "Дилеры",
        "broadcast.staff": "Сотрудники",
        "broadcast.history": "История",
        "broadcast.recipients": "Получатели",
        "broadcast.sentBy": "Отправил",
        "broadcast.date": "Дата",
        "broadcast.none": "Рассылок пока нет",
        "broadcast.sent": "Рассылка отправлена",
    },
    geo: {
        "broadcast.title": "მასობრივი შეტყობინება",
        "broadcast.compose": "ახალი განცხადება",
        "broadcast.subject": "სათაური",
        "broadcast.body": "ტექსტი",
        "broadcast.audience": "აუდიტორია",
        "broadcast.link": "ბმული (არასავალდებულო)",
        "broadcast.send": "გაგზავნა",
        "broadcast.all": "ყველა",
        "broadcast.dealers": "დილერები",
        "broadcast.staff": "თანამშრომლები",
        "broadcast.history": "ისტორია",
        "broadcast.recipients": "მიმღებები",
        "broadcast.sentBy": "გააგზავნა",
        "broadcast.date": "თარიღი",
        "broadcast.none": "შეტყობინებები ჯერ არ არის",
        "broadcast.sent": "შეტყობინება გაიგზავნა",
    },
};

export default broadcast;
